import { changeEvent, checkFormValidity, resetFormFields } from "../../form-store/action-types";
import { CITY_FIELD, COUNTRY_FIELD, COUNTY_FIELD, STATE_FIELD, ZIP_FIELD } from "../../config/stepper-form";
import { resetStateAndDependentField, toggleCountyRequiredField, updateCities, updateCounty, updateStates, updateZipCodes } from "../../util/utility";
import { addressCombo, resetAddressCombo, updateOptionsForState } from "../../form-store/app-reducer";
import serviceCall from "../../util/service";
import { Environment } from "../../Environment";

export const resetStateField = () => dispatch => {
  dispatch(resetFormFields({ [STATE_FIELD.name]: "", [CITY_FIELD.name]: "", [ZIP_FIELD.name]: "", [COUNTY_FIELD.name]: "" }));
};

// const resetStateAndDependentField = () => dispatch => {
//   dispatch(resetFormFields({ [STATE_FIELD.name]: "", [CITY_FIELD.name]: "", [ZIP_FIELD.name]: "", [COUNTY_FIELD.name]: "" }));
//   dispatch(resetCities());
//   dispatch(resetZipCodes());
//   dispatch(resetCountyOptions());

// };

// const resetCityAndDependentField = () => dispatch => {
//   dispatch(resetFormFields({ [CITY_FIELD.name]: "", [ZIP_FIELD.name]: "", [COUNTY_FIELD.name]: "" }));
//   dispatch(resetZipCodes());
//   dispatch(resetCountyOptions());};

// const resetZipCodeAndDependentField = () => dispatch => {
//   dispatch(resetFormFields({ [ZIP_FIELD.name]: "", [COUNTY_FIELD.name]: "" }));
//   dispatch(resetCountyOptions());
// };

// const resetCountyAndDependentField = () => dispatch => {
//   dispatch(resetFormFields({ [COUNTY_FIELD.name]: "" }));
// };

export const onStateChange = state => async dispatch => {
  try {
    dispatch(addressCombo({ state }));
    const response = await serviceCall(Environment.STATE_FIELDS.replace("{state_code}", state), "GET");
    dispatch(updateOptionsForState({ options: response.data.result }));
    // dispatch(resetCityAndDependentField());
    dispatch(updateCities());
    setTimeout(() => dispatch(checkFormValidity()), 100);
  } catch (error) {
    console.log(error);
    dispatch(resetAddressCombo());
  }
};

export const onSelectEvent = (name, value) => async (dispatch, getState) => {
  let obj = {
    key: name,
    value,
  };
  dispatch(changeEvent(obj));

  if (name === COUNTRY_FIELD.name) {
    dispatch(resetStateField());
    dispatch(toggleCountyRequiredField(value.value));
    dispatch(resetStateField());
    dispatch(updateStates(value.value));
    dispatch(resetStateAndDependentField());
  }
  const { form } = getState();
  const _ctryValue = form.customer.countryCode?.value;
  if (_ctryValue === "US") {
    if (name === STATE_FIELD.name) {
      dispatch(onStateChange(value.value));
    }
    if (name === CITY_FIELD.name) {
      // dispatch(resetZipCodeAndDependentField());
      dispatch(updateZipCodes());
    }
    if (name === ZIP_FIELD.name) {
      // dispatch(resetCountyAndDependentField());
      dispatch(updateCounty());
    }
  }
  setTimeout(() => dispatch(checkFormValidity()), 100);
};
